Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scalesPreset = void 0;
exports.scalesPreset = {
  fontSizeScale: [0, 8, 10, 12, 14, 16, 18, 20, 24, 32, 42, 56, 72],
  fontWeightScale: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900],
  lineHeightScale: [0, 1, 1.15, 1.25, 1.5, 1.75, 2],
  spaceScale: [0, 4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96]
};